import api from "api";

export const fetchFiles = async () => await api.get("/files");
export const searchFileByName = async (data) => await api.post("/files/searchByName", data);
